import { Col, DatePicker, Flex, Form, Row } from "antd";
import React, { useState } from "react";
import CustomSelect from "../../../components/common/CustomSelect";
import CustomInput from "../../../components/common/CustomInput";
import CustomButton from "../../../components/common/CustomButton";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";

const BankAccountDetailSecondForm = ({ name, ...restField }) => {
    const [showMore, setShowMore] = useState(false);
    const [dates, setDates] = useState({
        analysis1Start: null,
        analysis1End: null,
        analysis2Start: null,
        analysis2End: null,
        // Add more pairs as needed
    });
    const { bankOptions, bankOptionsLoading } = useSelector(({ createReport }) => createReport);

    const handleShowMore = () => {
        setShowMore(!showMore);
    }
    const onChange = (value) => {
        console.log(`selected ${value}`);
    };

    const onSearch = (value) => {
        console.log('search:', value);
    }

    // Handle start date changes for each pair
    const handleStartDateChange = (fieldStart, fieldEnd, date) => {
        setDates(prevDates => ({
            ...prevDates,
            [fieldStart]: date,
            // Clear end date if it becomes invalid
            [fieldEnd]: date && prevDates[fieldEnd] && date.isAfter(prevDates[fieldEnd], 'day') ? null : prevDates[fieldEnd]
        }));
    };

    // Handle end date changes for each pair
    const handleEndDateChange = (fieldStart, fieldEnd, date) => {
        setDates(prevDates => ({
            ...prevDates,
            [fieldEnd]: date,
            // Clear start date if it becomes invalid
            [fieldStart]: date && prevDates[fieldStart] && date.isBefore(prevDates[fieldStart], 'day') ? null : prevDates[fieldStart]
        }));
    };

    // Disable dates before analysis1Start in the analysis1End DatePicker
    const disableAnalysis1EndDate = (current) => {
        return current && dates.analysis1Start && current.isBefore(dates.analysis1Start, 'day');
    };

    // Disable dates after analysis1End in the analysis1Start DatePicker
    const disableAnalysis1StartDate = (current) => {
        return current && dates.analysis1End && current.isAfter(dates.analysis1End, 'day');
    };

    // Similarly for analysis2
    const disableAnalysis2EndDate = (current) => {
        return current && dates.analysis2Start && current.isBefore(dates.analysis2Start, 'day');
    };


    const disableAnalysis2StartDate = (current) => {
        return current && dates.analysis2End && current.isAfter(dates.analysis2End, 'day');
    };


    return (
        <>
            <Row>
                <Col lg={24}>
                    <Form.Item className='w-100' label="Bank Name" name={[name, "bankName"]} {...restField} required={true} rules={[{ required: false, message: "Please select a Bank Name" }]}>
                        <CustomSelect
                            className='w-100'
                            placeholder="Select Bank Name"
                            optionFilterProp="label"
                            onChange={onChange}
                            onSearch={onSearch}
                            options={bankOptions}

                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col lg={12}>
                    <Form.Item className='w-100' label="Account Type" name={[name, "accountType"]} {...restField} required={true} rules={[{ required: false, message: "Please Select an Account Type" }]}>
                        <CustomSelect
                            className='w-100'
                            placeholder="Current/Savings/OD or CC"
                            optionFilterProp="label"
                            onChange={onChange}
                            onSearch={onSearch}
                            options={[
                                {
                                    value: 'Current Account',
                                    label: 'Current Account',
                                },
                                {
                                    value: 'Savings Account',
                                    label: 'Savings Account',
                                },
                                // {
                                //     value: 'OD or CC Account',
                                //     label: 'OD or CC Account',
                                // },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col lg={12} >
                    <Form.Item className='w-100' label="Account Number" name={[name, "accountNumber"]} {...restField} required={true} rules={[{ required: false, message: "Please enter Account Number" }]}>
                        <CustomInput className='w-100' placeholder={"Enter Account Number"} />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col lg={12} >
                    <Form.Item className='w-100' label="Analysis From" name={[name, "analysisFrom"]} {...restField} required={false} rules={[{ required: false, message: "Please Select the date" }]}>
                        <DatePicker
                            className='w-100'
                            size="large"
                            format={"DD/MM/YYYY"}
                            value={dates.analysis1Start}
                            onChange={(date) => handleStartDateChange('analysis1Start', 'analysis1End', date)}
                            disabledDate={disableAnalysis1StartDate}
                        />
                    </Form.Item>
                </Col>
                <Col lg={12} >
                    <Form.Item className='w-100' label="Ananlysis To" name={[name, "analysisTo"]} {...restField} required={false} rules={[{ required: false, message: "Please Select the date" }]}>
                        <DatePicker
                            className='w-100'
                            size="large"
                            format={"DD/MM/YYYY"}
                            value={dates.analysis1End}
                            onChange={(date) => handleEndDateChange('analysis1Start', 'analysis1End', date)}
                            disabledDate={disableAnalysis1EndDate}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 16]}>
                <Col lg={12} >
                    <Form.Item className='w-100' label="Statement Starts From" name={[name, "statementStartsFrom"]} {...restField} required={false} rules={[{ required: false, message: "Please Select Statement Start date" }]}>
                        <DatePicker
                            className='w-100'
                            size="large"
                            format={"DD/MM/YYYY"}
                            value={dates.analysis2Start}
                            onChange={(date) => handleStartDateChange('analysis2Start', 'analysis2End', date)}
                            disabledDate={disableAnalysis2StartDate}
                            autoComplete="new-password"

                        />
                    </Form.Item>
                </Col>
                <Col lg={12} >
                    <Form.Item className='w-100' label="Statement Ends From" name={[name, "statementEndsFrom"]} {...restField} required={false} rules={[{ required: true, message: "Please Select Statement End date" }]}>
                        <DatePicker
                            className='w-100'
                            size="large"
                            format={"DD/MM/YYYY"}
                            value={dates.analysis2End}
                            onChange={(date) => handleEndDateChange('analysis2Start', 'analysis2End', date)}
                            disabledDate={disableAnalysis2EndDate}
                            autoComplete="new-password"

                        />
                    </Form.Item>
                </Col>
            </Row>
            {
                // showMore && (
                <div style={{ display: showMore ? "block" : "none" }}>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Account Opening Data" name={[name, "accountOpeningDate"]} {...restField} required={false} rules={[{ required: false, message: "Please Select Account Opening Date" }]}>
                                <DatePicker className='w-100' size="large" format={"DD/MM/YYYY"} />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Account Status" name={[name, "accountStatus"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Account Status" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="IFSC Code" name={[name, "ifscCode"]} {...restField} required={false} rules={[{ required: false, pattern: '^[A-Z]{4}0[0-9]{6}$', message: "Please enter valid IFSC Code ex. 'ABCD0001234'" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="MICR Code" name={[name, "micrCode"]} {...restField} required={false} rules={[{ required: false, pattern: '^[0-9]{9}$', message: "Please enter valid MICR Code ex. '458585855'" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Branch Name" name={[name, "branchName"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Branch Name" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Branch Address" name={[name, "branchAddress"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Branch Address" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Account Holder Name" name={[name, "accountHolderName"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Account Holder Name" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Joint Holder Name" name={[name, "jointHolderName"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Joint Account Holder Name" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Email Address" name={[name, "email"]} {...restField} required={false} rules={[{ required: false, pattern: '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$', message: "Please enter valid Account Holder Email" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Phone Number" name={[name, "phone"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Account Holder Phone Number" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]}>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="PAN" name={[name, "pan"]} {...restField} required={false} rules={[{ required: false, pattern: '^[A-Z]{5}[0-9]{4}[A-Z]{1}$', message: "Please enter valid Account Holder PAN ex. 'ABCDE1234F'" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                        <Col lg={12}>
                            <Form.Item className='w-100' label="Account Holder Address" name={[name, "address"]} {...restField} required={false} rules={[{ required: false, message: "Please enter Account Holder Address" }]}>
                                <CustomInput className='w-100' />
                            </Form.Item>
                        </Col>
                    </Row>
                </div>
                // )
            }
            <Flex justify="end">
                <CustomButton onClick={handleShowMore} icon={showMore ? <MinusOutlined /> : <PlusOutlined />} type="outLine" style={{ marginRight: "16px" }}>{
                    showMore ? "Show Less" : "Show More"
                }</CustomButton>
            </Flex>
        </>
    );
};

export default BankAccountDetailSecondForm;